import { useState, useEffect } from 'react';
import axios from 'axios';
import endpoints from '../settings/endpoints';

/**
 * Custom hook to fetch movies based on a given query.
 * 
 * @param {string} query - The status to query movies by.
 * @returns {Array} - An array containing the fetched movies, the loading state, and any error encountered.
 */
function useFetchMovies(query) {
    const [vids, setVids] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${endpoints.baseUrl}${endpoints.endpoints.getMoviePosts}`, {
                    params: { status: query }  // Adjust parameter name based on your API's requirement
                });

                setVids(response.data);  //  API returns the list of vids directly.
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);  // Ensure loading is set to false even if there's an error
            }
        };

        fetchData();
    }, [query]);

    return [vids, loading, error];
}

export default useFetchMovies;
